<template>
	<div class="index">
		<van-nav-bar title="" left-text="" @click-left="toService" left-arrow fixed>
		  <template #title>
		    <div class="van-image" style="width: 90px;">
		    	<!-- <img src="/img/logo2a.png" class="van-image__img"> -->
				Desire Club
			</div>
		  </template>
		  <template #left>
		    <van-icon name="chat-o" size="26" />
		  </template>
		</van-nav-bar>

		<div class="banner banners index-banner">
			<swiper class="swiper" :options="bannerSwiperOption">
			  <swiper-slide v-for="(v,key) in banners" :key="key">
					<a>
						<img class="banner_img"  :src="v.url" />
					</a>			      
			  </swiper-slide>
			</swiper>
			
		</div>
		<div class="item">
			<div class="title">
				<span class="animate__animated animate__fadeIn">
					HOT
					<i style="font-size: 14px;">
						{{$t('home.gonggao')}}
					</i>

				</span>
			</div>
			<div class="girl">
				<div>
					<ul class="gaoduan">
						<li v-for="(v,key) in osList" :key="key" @click="profile(v.id)" >
							<img :src="v.image" alt="">
							<p>
								{{$t('person1')}}
							</p>
							<span>
								<i>
									{{$t('home.qgkf')}}
								</i>
							</span>
						</li>
					</ul>
					<ul class="gaoduan">
						<li v-for="(v,key) in jsList" :key="key" @click="profile(v.id)">
							<img :src="v.image" alt="">
							<p>
								{{$t('person2')}}
							</p>
							<span>
								<i>
									{{$t('home.qgkf')}}
								</i>
							</span>
						</li>
						
					</ul>
				</div>
				<a @click="$router.push({path:'/Choose'});" >
					{{$t('common.more')}}
				</a>
			</div>
		</div>
		<!-- <div class="item">
			<div class="title">
				<span class="animate__animated animate__fadeIn">
					{{$t('home.hotgame')}}
				</span>
			</div>
			<ul class="list">
				<li  @click="toLottery(v.key,v.id)" v-for="(v,key) in gameitem" :key="key">
					<div class="image">
						<img class="animate__animated animate__flipInX" alt=""  :src="v.ico"></div>
					<p>
						{{v.name}}
					</p>
				</li>
				
			</ul>
		</div> -->
		<div class="item item-hotlist">
			<div class="title">
				<span class="animate__animated animate__fadeIn">
					{{$t('home.hotlist')}}
				</span>
				<span class="animate__animated animate__fadeIn" @click="toProfile()">
					See more >>
				</span>
			</div>
			<div class="tj">
				<ul>
					<li v-for="(v,key) in movielist_1" :key="key"  >
						<div class="left">
							<div class="left-inner">
								<img :src="v.image" alt="">
								<p>{{v.class_name}}</p>
							</div>
							<span>
								<i>
									{{$t('home.gaoji')}}
								</i>
							</span>
						</div>
						<div class="right">
							<div class="title">
								<span class="badge-tag">
									<span class="van-badge__wrapper van-icon"><img class="van-icon__image" src="/img/vipu.png"></span>
									{{$t('home.smrz')}}
								</span>
								<span class="badge-tag">
									<span class="van-badge__wrapper van-icon"><img class="van-icon__image" src="/img/vipu.png"></span>
									{{$t('home.videorz')}}
								</span>
							</div>
							<div class="tips">
								<span v-for="(val,index) in v.tags_arr" :key="index"  >
									{{val}}
								</span>

							</div>
							<div class="sm">
								<p class="sf">
									{{$t('home.star')}}：
									<span v-for="(numa,indexs) in v.star" :key="indexs" ></span>
								</p>
								<div>
									{{$t('home.sg')}}: ***  {{$t('home.xw')}}：*** {{$t('home.diqu')}}：***
								</div>
								<!-- <div>
									{{$t('home.sg')}}: {{v.sg}}cm {{$t('home.xw')}}：{{v.sw}}{{$t('home.diqu')}}：{{v.class_name}}
								</div> -->
							</div>
							<div class="btn"  @click="profile(v.id)">
								{{$t('home.apply')}}
							</div>
						</div>
					</li>
				</ul>
			</div>
		</div>
		<div class="gundong">
			<p>{{$t('home.ssxz')}}</p>
			<div class="marquee-wrap">
				<div class="marquee-content">
					<div class="marquee-item" v-for="(v,key) in vip_list" :key="'a'+key">{{v}} {{$t('home.joinvip')}}</div>
					<div class="marquee-item" v-for="(v,key) in vip_list" :key="'b'+key">{{v}} {{$t('home.joinvip')}}</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
  data() {
    return {
      notice: "获取中......",
      banners: [],
      basicData:[],
      gameitem: [{},{},{},{}],
      movielist_0: [{},{},{},{}],
      movielist_1: [{},{},{},{},{},{},{},{}],
      vip_list: [],
      isLoading: false,
      movielistSwiperOption: {
        slidesPerView: 'auto',
        spaceBetween: 0,
        slidesPerGroup : 1,
      },
      bannerSwiperOption: {
        loop: true,
        speed:1000,
        autoplay:true
      },
    };
  },
  computed: {
      osList() {
        return this.movielist_0.filter((item, index) => index % 2 === 0);
      },
	  jsList() {
	    return this.movielist_0.filter((item, index) => index % 2 === 1);
	  },
    },
  methods:{
    gotoMenu(router){
      this.$router.replace(router)
    },
    toLottery(key,id){
      if(!localStorage.getItem('token')){
        this.$router.push({path:'/Login'})
      }else {
        this.$router.push({path:'/Lottery?key='+key+"&id="+id})
      }

    },
	toProfile() {
		this.$router.push({ path: '/Choose'});
	},
	profile(id) {
		this.$router.push({ path: '/profile?id=' + id  });
	},
	toService(){
	  if(this.$store.getters.getBaseInfo.iskefu == 1){
	    this.$router.push("ServiceOnline");
	  }else {
	    this.$toast(this.$t('common.refresh'));
	  }
	},
    toPlayVideo(id){
      if(!localStorage.getItem('token')){
        this.$router.push({path:'/Login'})
      }else {
        this.$router.push({path:'/PlayVideo?id='+id})
      }
    },
    onRefresh() {
      setTimeout(() => {
        this.getBasicConfig();
        this.isLoading = false;
        this.$toast(this.$t('common.refresh'));
      }, 500);
    },
    getBasicConfig(){
      this.$http({
        method: 'get',
        url: 'sys_config'
      }).then(res=>{
        this.basicData = res.data;
		
		this.vip_list = this.basicData.vip_list;
        this.getNotice(this.basicData);//获取公告
        this.getBanner(this.basicData);//获取banner
        this.getGameItem();//获取首页游戏列表
        this.getMovieList_0(this.basicData);//获取首页视频0
        this.getMovieList_1(this.basicData);//获取首页视频1
      })

    },
    getNotice(data){
      this.notice = data.notice;
    },
    getGameItem(){
      this.$http({
        method: 'get',
        url: 'lottery_hot'
      }).then(res=>{
		  console.log(res.data);
        this.gameitem = res.data
      })
    },
    getMovieList_0(data){
      this.movielist_0 = data.movielist_0
    },
    getMovieList_1(data){
      this.movielist_1 = data.movielist_1
    },
    getBanner(data){
      this.banners = data.banners;
    }
  },
  mounted () {

  },
  created() {
    this.getBasicConfig();
  }
}

</script>

<style lang='less' scoped>
@import "../../assets/css/basenew.css";

.van-nav-bar {
    z-index: 999;
    position: absolute;
    background: url(/img/header.svg) no-repeat 50%/100%;
}

/* 首页样式优化 */
.index {
    background: #000000;
}

.index-banner {
    margin: 0.2rem 0.66667rem 0;
    height: 10rem;
    border-radius: 0.53333rem;
    overflow: hidden;
    box-shadow: 0 0.26667rem 0.8rem rgba(125, 118, 239, 0.2);
}

.index-banner .banner_img {
    object-fit: cover;
    width: 100%;
    height: 100%;
}

.index .item {
    padding: 0.8rem 0.66667rem;
}

.index .item-hotlist .title {
    padding-bottom: 0.66667rem;
}

.index .item .title span {
    font-weight: 600;
    font-size: 0.85rem;
	color: #fafafa;
}

.index .item .title span i {
    font-size: 0.65rem;
    padding: 0.08rem 0.5rem;
}

/* HOT 卡片优化 */
.index .gaoduan li {
    border-radius: 0.4rem;
    box-shadow: 0 0.13333rem 0.4rem rgba(0, 0, 0, 0.08);
    transition: transform 0.25s ease, box-shadow 0.25s ease;
}

.index .gaoduan li:active {
    transform: scale(0.98);
}

.index .gaoduan li p {
    font-size: 0.75rem;
    padding-bottom: 0.4rem;
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);
}

/* 游戏列表优化 */
.index .item .list li {
    transition: transform 0.2s ease;
}

.index .item .list li:active {
    transform: scale(0.95);
}

.index .item .list li .image {
    border-radius: 0.4rem;
    overflow: hidden;
}

.index .item .list li p {
    font-weight: 500;
}

/* 人气推荐列表优化 */
.index .tj ul {
    padding: 0 0.2rem;
}

.index .tj ul li {
    padding: 0.8rem;
    border-radius: 0.4rem;
    margin-bottom: 0.8rem;
    border: none;
    background: #fff;
    box-shadow: 0 0.06667rem 0.26667rem rgba(0, 0, 0, 0.06);
    transition: box-shadow 0.25s ease;
}

.index .tj ul li:active {
    box-shadow: 0 0.13333rem 0.4rem rgba(125, 118, 239, 0.15);
}

.index .tj .left-inner {
    display: flex;
    flex-direction: column;
}

.index .tj .left-inner p {
    margin-top: 0.4rem;
    font-size: 0.8rem;
    color: #ffffff;
}


.index .tj .right .btn {
    transition: opacity 0.2s ease;
}

.index .tj .right .btn:active {
    opacity: 0.9;
}
.index .tj .badge-tag {
    color: #4f4f4f !important;
	font-size: 0.6rem !important;
}
.index .tj .badge-tag .van-badge__wrapper {
    font-size: 0.8rem;
}

/* 底部轮播优化 */
.index .gundong {
    margin-top: 1rem;
    margin-bottom: 0.5rem;
    box-shadow: 0 0.26667rem 0.8rem rgba(254, 89, 134, 0.25);
}

/* 更多按钮优化 */
.index .girl>a {
    border-radius: 2rem;
    transition: background 1s ease, color 1s ease;
}

.index .girl>a:active {
    background: #eee;
    color: #666;
}
</style>
